import axios from 'axios';
import { getUrlParam } from '../../../utils/url';
import formEventBus, { FORM_EVENTS_TYPE } from '../../../utils/event-bus';
import { getSig4ConfigParams } from './sig4';
import { getSig4RequestInterceptor } from '@ks-cqc/ks-fe-sig4-interceptor/perf-fast';
import Cookies from 'js-cookie';


const laneId = getUrlParam('laneId');
const laneIdHeader = laneId ? { 'trace-context': `{"laneId":"${laneId}"}` } : {};
export const $http = axios.create({
    timeout: 5e3,
    headers: {
        ...laneIdHeader,
    },
});

export const apiCategoty = {
    network: 'network',
    biz: 'biz',
    request: 'request',
    success: 'success',
};

export const resultType = {
    Success: 'success',
    Fail: 'fail',
    Pending: 'pending',
    Unset: '',
};

const sendApiLog = (category, extraParams) => {
    formEventBus && formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'API', category, extraParams);
};

const CANCEL_ERROR_MESSAGE = '请求被取消了';
const DEFAULT_ERROR_MESSAGE = '请求出错了，请稍后再试';
function rejectHandle(errData) {
    return Promise.reject(errData);
}

function generateRandomThreeDigitNumber() {
    return Math.floor(Math.random() * 900) + 100;
}

// 安全地初始化sig4拦截器
const sig4RequestInterceptor = getSig4RequestInterceptor({
    ...getSig4ConfigParams(),
    debug: process.env.NODE_ENV === 'development',
    prefetchSigSdk: true,
    projectInfo: {
        oversea: false, // 默认false
        appKey: '8NFTvh9XS9',
        uid: Cookies.get('userId') || Cookies.get('uid'),
        did: Cookies.get('did') || '',
    },
});
$http.interceptors.request.use(sig4RequestInterceptor);
$http.interceptors.request.use(function (config) {
    const { url } = config;
    const urlApi = url.match(/[^/]+$/);
    config.requestCk = document.cookie ? document.cookie.length : 0;
    const randomId = `${generateRandomThreeDigitNumber()}-${Date.now()}`;
    config.randomId = randomId;
    const extraParams = {
        result: resultType.Pending,
        ck: config.requestCk,
        randomId,
        url: url,
        urlApi,
        data: config.data,
    };
    sendApiLog(apiCategoty.request, extraParams);
    return config;
}, function (error) {
    return Promise.reject(error);
});

$http.interceptors.response.use(res => {
    // 缺省后端错误result!=1
    if (res.data.result !== 1) {
        const config = res.config;
        const { url, randomId = '', requestCk = '' } = config;
        const extraParams = {
            result: resultType.Fail,
            message: res.data.error_msg || '缺省后端错误result!=1',
            randomId,
            url,
            ck: requestCk,
            data: res.data,
        };
        sendApiLog(apiCategoty.biz, extraParams);
        return Promise.reject({ message: res.data.error_msg,
            config: res.config });
    }
    const succseeParams = {
        result: resultType.Success,
        randomId: res.config.randomId || '',
        data: res.data,
        url: res.config.url,
    };
    sendApiLog(apiCategoty.success, succseeParams);
    return res;
}, error => {
    if (!error.config || !error.config.url) {
        return rejectHandle(CANCEL_ERROR_MESSAGE);
    }
    const config = error.config;
    const { requestCk = '', randomId = '' } = config;
    const extraParams = {
        result: resultType.Fail,
        message: error.error_msg || '缺省网络请求错误code!=200',
        url: config.url,
        data: error.response.data || '',
        ck: requestCk,
        randomId,
    };
    sendApiLog(apiCategoty.network, extraParams);
    return rejectHandle(error || DEFAULT_ERROR_MESSAGE);
});

export const MULTIPART_FORM_DATA_CONFIG = {
    headers: { 'Content-Type': 'multipart/form-data', ...laneIdHeader },
};

export const $fileUploader = axios.create({
    ...MULTIPART_FORM_DATA_CONFIG,
    timeout: 0, // 上传文件就不设置timeout了
});
